import _ from "@lodash";
import XAPPService from "app/Core/services/XAPPService";
export const TOGGLE_AGENDA_PAINEL = "[AGENDA PAINEL] TOGGLE AGENDA PAINEL";
export const GET_AGENDA_PAINEL = "[AGENDA PAINEL] GET AGENDA PAINEL";
export const GET_AGENDA_PAINEL_TIPOS = "[AGENDA PAINEL] GET AGENDA PAINEL TIPOS";
export const AGENDA_PAINEL_ERROR = "[AGENDA PAINEL] AGENDA PAINEL ERROR";
export const AGENDA_PAINEL_CHANGE_PRELOAD = "[AGENDA PAINEL] AGENDA PAINEL CHANGE PRELOAD";

const ListState = [
    "descricao",
    "prazo",
    "tipo",
    "rota",
    "acao",
    "ordenacao",
    "cor",
    "whatsapp",
    "email"
];

const TiposState = [
    "tipo",
    "tiponome",
    "tipoicone",
    "total"
];

export function toggleAgenda() {
    return {
        type: TOGGLE_AGENDA_PAINEL
    }
}

export function list(_AParams, _AFiltro = null, _OpenDefault = true) {

    return (dispatch, getState) => {
        if (_OpenDefault && !getState().AgendaReducer.open) {
            dispatch({ type: TOGGLE_AGENDA_PAINEL });
        }
        dispatch(changePreload(true));

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (!_.isNull(_AFiltro)) {
            if (!_.isNull(_AFiltro.inicio)) {
                AConditionsAND.push({ "Campo": "inicio", "Operador": "=", "Valor": _AFiltro.inicio });
            }
            if (!_.isNull(_AFiltro.termino)) {
                AConditionsAND.push({ "Campo": "termino", "Operador": "=", "Valor": _AFiltro.termino });
            }
            if (!_.isNull(_AFiltro.tipos)) {
                let ATipos = _AFiltro.tipos.map(item => ("{" + item + "}")).join();
                AConditionsAND.push({ "Campo": "tipos", "Operador": "=", "Valor": ATipos });
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "AgendaPainel", AActions, "spvwagendapainel", ListState, "SELECIONAR", AConditionsAND, AConditionsOR)
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "AgendaPainelTipo", AActions, "spvwagendapaineltipo", TiposState, "SELECIONAR", AConditionsAND, AConditionsOR)

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_AGENDA_PAINEL,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    }),
                    dispatch({
                        type: GET_AGENDA_PAINEL_TIPOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                    }),
                ])
            )
            .catch(error => {
                Promise.all([
                    dispatch({
                        type: AGENDA_PAINEL_ERROR,
                        payload: error
                    }),
                    dispatch(changePreload(false))
                ]);
            });
    };
}


function changePreload(preload = false) {
    return {
        type: AGENDA_PAINEL_CHANGE_PRELOAD,
        preload
    }
}